export default "__VITE_ASSET__x7V2LCSD__"